import React from 'react';
import MockHeader from './MockHeader';
import SimpleMap from '../../features/Map/SimpleMap';
import {
  MAPBOX_ACCESS_TOKEN,
  MAPBOX_STYLE_TOKEN,
} from '../../features/Map/MapHelper';

const Background = () => {
  return (
    <>
      <MockHeader />
      <SimpleMap
        accessToken={MAPBOX_ACCESS_TOKEN as string}
        styleUrl={MAPBOX_STYLE_TOKEN as string}
      />
    </>
  );
};

export default Background;
